import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'common-make-changes',
  templateUrl: './make-changes.component.html',
  styleUrls: ['make-changes.component.scss'],
})
export class MakeChangesComponent implements OnInit {
  @Input() brandColor!: string;
  @Input() textColor!: string;
  @Input() fontWeight?: string;
  @Input() trackableUrl!: string;
  @Input() nativeTrackingUrl!: string;
  @Input() isFinalStatus!: boolean;
  @Input() linkTextOverride?: string;

  @HostBinding('style.--text-color') cssTextColor: string = '#fff';
  @HostBinding('style.--font-weight') cssFontWeight: string = '550';
  @HostBinding('style.--color') cssColor: string | undefined;

  linkText = 'Make changes to your order';

  ngOnInit(): void {
    this.cssTextColor = this.textColor || '#fff';
    this.cssFontWeight = this.fontWeight || '550';
    this.cssColor = this.brandColor;

    this.linkText = this.linkTextOverride
      ? this.linkTextOverride
      : this.isFinalStatus
        ? 'Additional order info'
        : 'Make changes to your order';
  }
}
